import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import logo from "../images/amaxTextWhite.png";
import heroBg from "../images/heroBg.png";
import onSite from "../images/onSite.png";
import result from "../images/result.png";
import remoteTraining from "../images/remote-training.png";
import coachesConsulting from "../images/coaches-consulting.png";
import systemBg from "../images/TheSystem.png";
import cw1 from "../images/cw-1.png";
import cw2 from "../images/cw-2.png";
import cw3 from "../images/cw-3.png";
import logoCircle from "../images/amaxLogo.png";
import client from "../images/client.jpg";
import hamburger from "../images/hamburger.svg";
import instagram from "../images/instagram.svg";
import facebook from "../images/facebook.svg";
import KeelanWright from "../images/KeelanWright.jpg";
import NichellePrince from "../images/NichellePrince.jpg";
import AriikeElijah from "../images/AriikeElijah.jpg";
import evaNgom from "../images/evaNgom.jpg";
import HumzaBaig from "../images/HumzaBaig.jpg";
import ChristianPleasant from "../images/ChristianPleasant.jpg";
import fox from "../images/fox.jpg";
import CelesteRobinson from "../images/CelesteRobinson.jpg";

const AthleteStartNew = () => {
  return (
    <>
      <TheStart />
      <TheStandard />
      <TheSystem />
      <TheCarousel />
      <TheResult />
      <TheTrust />
      <TheLast />
    </>
  );
};

export default AthleteStartNew;

const TheStart = () => {
  return (
    <>
      <div className="relative min-h-screen py-5 flex flex-col justify-between items-stretch">
        <div className="w-full max-w-2xl px-5 mx-auto">
          <div className="flex justify-between items-center">
            <Link to="/" className="max-w-20">
              <img
                src={logo}
                alt="logo"
                className="w-full h-full object-contain"
              />
            </Link>

            {/* hamburger / menu btn */}
            {/* <div>
              <button className="w-6 h-6 bg-transparent border-none outline-none">
                <img src={hamburger} alt="icon" className="w-full h-full" />
              </button>
            </div> */}
          </div>
        </div>

        <div className="w-full max-w-2xl px-5 mx-auto mb-20">
          <div className="space-y-5 mt-auto">
            <h1 className="text-white font-roboto font-black text-2xl sm:text-3xl uppercase">
              BUILT FOR ATHLETES <br /> WHO TRAIN WITH PURPOSE.
            </h1>
            <p className="text-white font-roboto font-medium text-lg leading-snug">
              Elite Speed Development: <br />
              Structured. Measured. Earned.
            </p>

            <Link
              to="/athlete/start"
              className="w-fit block text-center py-3 px-8 text-black font-roboto text-lg leading-none bg-darkYellow hover:bg-yellow-600 rounded-lg capitalize transition-all duration-300"
            >
              Apply to Train
            </Link>
          </div>
        </div>

        <div className="absolute inset-0 -z-10">
          <img
            src={heroBg}
            alt="heroBg"
            className="w-full h-full object-cover object-center"
          />
        </div>
      </div>
    </>
  );
};
const TheStandard = () => {
  return (
    <>
      <div className="relative min-h-screen pt-16">
        <div className="w-full max-w-xs text-center px-5 mx-auto mb-10">
          <h2 className="text-black font-roboto font-bold text-2xl sm:text-3xl uppercase mb-5">
            THE STANDARD.
          </h2>

          <div className="space-y-3 w-full max-w-xs mx-auto text-slate-800 font-roboto font-normal text-lg">
            <p>Speed isn’t built by volume.</p>
            <p>It’s built by structure, precision, and progression.</p>
          </div>
        </div>
        <div className="flex flex-col gap-8">
          {/* card 1 */}
          <div className="relative px-8 py-14">
            <div className="space-y-10 text-center w-full max-w-xs mx-auto">
              <div className="space-y-2">
                <h2 className="text-white font-roboto font-bold text-2xl sm:text-3xl uppercase">
                  ON-SITE TRAINING
                </h2>
                <p className="text-white font-roboto font-normal text-base">
                  In-person speed development built on technical execution and
                  progression.
                </p>
              </div>

              <div>
                <Link
                  to="https://app.glofox.com/portal/#/branch/68b0a5af3b24dc4faa01b5d7/lead-register"
                  target="_blank"
                  className="w-fit mx-auto block text-center py-3 px-8 text-black font-roboto text-lg leading-none bg-darkYellow hover:bg-yellow-600 rounded-lg uppercase transition-all duration-300"
                >
                  get started.
                </Link>
              </div>
            </div>

            {/* bg image */}
            <div className="absolute inset-0 -z-10">
              <img
                src={onSite}
                alt="onSite"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          {/* card 2 */}
          <div className="relative px-8 py-14">
            <div className="space-y-10 text-center w-full max-w-xs mx-auto">
              <div className="space-y-2">
                <h2 className="text-white font-roboto font-bold text-2xl sm:text-3xl uppercase">
                  REMOTE TRAINING
                </h2>
                <p className="text-white font-roboto font-normal text-base">
                  Structured programming with performance tracking and direct
                  coaching feedback.
                </p>
              </div>

              <div>
                <Link
                  to="https://calendly.com/amaxspeed/program-training-inquiry"
                  target="_blank"
                  className="w-fit mx-auto block text-center py-3 px-8 text-black font-roboto text-lg leading-none bg-darkYellow hover:bg-yellow-600 rounded-lg uppercase transition-all duration-300"
                >
                  get started.
                </Link>
              </div>
            </div>

            {/* bg image */}
            <div className="absolute inset-0 -z-10">
              <img
                src={remoteTraining}
                alt="remoteTraining"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          {/* card 3 */}
          <div className="relative px-8 py-14">
            <div className="space-y-10 text-center w-full max-w-xs mx-auto">
              <div className="space-y-2">
                <h2 className="text-white font-roboto font-bold text-2xl sm:text-3xl uppercase">
                  COACH CONSULTING
                </h2>
                <p className="text-white font-roboto font-normal text-base">
                  System design and technical guidance for teams and coaches.
                </p>
              </div>

              <div>
                <Link
                  to="https://calendly.com/amaxspeed/coaching-consulting-meeting"
                  target="_blank"
                  className="w-fit mx-auto block text-center py-3 px-8 text-black font-roboto text-lg leading-none bg-darkYellow hover:bg-yellow-600 rounded-lg uppercase transition-all duration-300"
                >
                  get started.
                </Link>
              </div>
            </div>

            {/* bg image */}
            <div className="absolute inset-0 -z-10">
              <img
                src={coachesConsulting}
                alt="coachesConsulting"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const TheSystem = () => {
  return (
    <>
      <div className="relative pt-16">
        <div className="w-full max-w-xs text-center px-5 mx-auto mb-10">
          <h2 className="text-black font-roboto font-black text-2xl sm:text-3xl uppercase mb-5">
            THE SYSTEM.
          </h2>

          <div className="space-y-3 w-full max-w-xs mx-auto text-slate-800 font-roboto font-medium text-lg">
            <p>
              AST™ <br />
              Measured. Modeled. Developed.
            </p>
          </div>
        </div>

        <div className="w-full max-w-xs mx-auto px-5 pb-10">
          <img
            src={systemBg}
            alt="systembg"
            className="object-contain w-full h-full"
          />
        </div>
        <div className="w-full max-w-xs mx-auto px-5 pb-14 bg-black">
          <div>
            <Link
              to="/athlete/start"
              className="w-fit mx-auto block text-center py-4 px-8 text-black font-roboto text-xl leading-none bg-darkYellow hover:bg-yellow-600 rounded-3xl uppercase transition-all duration-300"
            >
              access now
            </Link>
          </div>
        </div>

        {/* black bg */}
        <div className="absolute bottom-0 left-0 right-0 -z-10 h-[30%] bg-black ">
          <div className="w-full h-full max-w-sm mx-auto flex flex-row justify-center gap-[33.33%]">
            <div className="h-full w-px bg-white/20"></div>
            <div className="h-full w-px bg-white/20"></div>
          </div>
        </div>

        {/* lines */}
        <div className="absolute top-0 left-0 right-0 -z-10 h-[70%]">
          <div className="w-full h-full max-w-sm mx-auto flex flex-row justify-center gap-[33.33%]">
            <div className="h-full w-px bg-black/20"></div>
            <div className="h-full w-px bg-black/20"></div>
          </div>
        </div>
      </div>
    </>
  );
};
const TheCarousel = () => {
  const cards = [
    // CARD 1 — CUSTOM WORKOUTS
    {
      title: "CUSTOM WORKOUTS.",
      description:
        "Every workout is designed around a defined goal time — acceleration, max velocity, speed endurance, or race execution.",
      image: cw1,
    },
    // CARD 2 — TRAIN WITH TARGETS
    {
      title: "TRAIN WITH TARGETS",
      description:
        "Using MySplit target times athletes train with defined performance benchmarks — building speed through measurable progression, not guesswork. ",
      image: cw2,
    },
    // CARD 3 — RACE MODEL™.
    {
      title: "RACE MODEL™.",
      description:
        "Event-specific performance insight built for measurable improvement. ",
      image: cw3,
    },
  ];
  return (
    <>
      <div className="relative  py-20">
        <div className="relative w-full max-w-sm mx-auto starterCarousel">
          <Swiper
            className="!pb-10"
            spaceBetween={28}
            modules={[Pagination]}
            pagination={{
              clickable: true,
              renderBullet: function (index, className) {
                return `<span class="${className} custom-bullet"></span>`;
              },
            }}
            onSwiper={(swiper) => console.log(swiper)}
          >
            {cards.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div id={index} className="flex flex-col gap-14">
                    <div className="relative w-full max-w-52 mx-auto">
                      <img
                        src={item.image}
                        alt=""
                        className="w-full h-full rounded-lg drop-shadow-lg"
                      />
                    </div>
                    <div className="space-y-3 text-center">
                      <h3 className="text-black font-roboto font-black text-2xl sm:text-3xl uppercase">
                        {item.title}
                      </h3>

                      <p className="text-black font-roboto font-medium text-lg leading-snug">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {/* background lines */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#dbdbdb] to-white -z-10 flex justify-center gap-[33.33%]">
          <div className="w-full max-w-sm mx-auto flex justify-center gap-[33.33%]">
            <div className="h-full w-px bg-gray-400"></div>
            <div className="h-full w-px bg-gray-400"></div>
          </div>
        </div>
      </div>
    </>
  );
};
const TheResult = () => {
  return (
    <>
      <div className="relative">
        <div className="">
          <div className="relative w-full max-w-lg mx-auto overflow-hidden">
            <div className="relative grid grid-cols-4 min-h-[700px]">
              {/* Left Vertical Text */}
              <div className="col-span-1 flex items-center justify-center border-r border-black">
                <h2 className="rotate-180 [writing-mode:vertical-rl] font-roboto text-6xl font-black">
                  THE RESULTS.
                </h2>
              </div>

              {/* Right Content */}
              <div className="col-span-3 flex flex-col py-10">
                {/* Block 1 */}
                <div className="flex-1 flex flex-col justify-center items-start border-t border-b border-black px-6">
                  <h3 className="text-6xl font-roboto font-black">50+</h3>
                  <p className="mt-2 text-lg font-roboto font-medium">
                    Collegiate Scholarship Earned
                  </p>
                </div>

                {/* Block 2 */}
                <div className="flex-1 flex flex-col justify-center items-start border-b border-black px-6">
                  <h3 className="text-6xl font-roboto font-black">30+</h3>
                  <p className="mt-2 text-lg font-roboto font-medium">
                    State/National Champions
                  </p>
                </div>

                {/* Block 3 */}
                <div className="flex-1 flex flex-col justify-center items-start px-6 border-b border-black">
                  <h3 className="text-6xl font-roboto font-black">100+</h3>
                  <p className="mt-2 text-lg font-roboto font-medium">
                    Athletes Trained Monthly
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* background */}
        <div className="absolute inset-0 -z-10">
          <img
            src={result}
            alt="result"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </>
  );
};
const TheTrust = () => {
  const testimonials = [
    {
      name: "Keelan Wright",
      image: KeelanWright,
      text: `The training program has been a game-changer for my
                      daughter, elevating her performance to the next level.
                      What sets this program apart is the incredible level of
                      detail in every aspect. Each workout is meticulously
                      tailored to align with her specific sport and events,
                      ensuring that her training directly translates to improved
                      performance on the field.`,
    },
    {
      name: "Nichelle Prince",
      image: NichellePrince,
      text: `Jason and AMAX Speed Training are exceptional. As a pro
                      soccer player seeking off- season speed work, I was
                      impressed by Jason's detailed, passion-driven approach.
                      Despite not being a track sprinter, he welcomed me and
                      focused on form, strength, and mechanics, ensuring
                      progress without injury. In just a few months, I improved
                      my speed, fitness, and strength, entering the season
                      strong. I highly recommend Jason and AMAX for speed
                      training.`,
    },
    {
      name: "Ariike Elijah",
      image: AriikeElijah,
      text: `AMAX is the place to be if you're looking to take your
                      speed to the next level. The coaches truly care about your
                      progress and you as a person. They are very knowledgeable
                      and even integrate technology into the program to help you
                      run faster. I saw significant improvement in my times and
                      I'm highly grateful for the support I received during my
                      time at AMAX, and even once I graduated and went on to
                      university.`,
    },
    {
      name: "Eva Ngom",
      image: evaNgom,
      text: ` AMAX has helped me grow into the athlete I am today. I
                      trained with them for only a year and saw major results.
                      They not only help you physically but mentally as well.
                      It's not just a training facility it's a family!!`,
    },
    {
      name: "Humza Baig",
      image: HumzaBaig,
      text: ` Started in June 2023, AMAX has taken me from a sub-par JV
                      athlete to one of the best in my area. I started with a
                      top speed of 21.6 mph, many girls were faster than that,
                      and of last season I hit 23.9mph, excited to see what I
                      can do this 2025 outdoor season and I trust AMAX every
                      step of the way!`,
    },
    {
      name: "Christina Pleasant",
      image: ChristianPleasant,
      text: `I was able to gain more knowledge on speed/power
                      development than before and understood the why behind it.
                      I would 1000% recommend this program.`,
    },
    {
      name: "Fox",
      image: fox,
      text: `Very thorough training program, explanations are perfect
                      and designed to each athlete for their individual needs.`,
    },
    {
      name: "Celeste Robinson",
      image: CelesteRobinson,
      text: `The way Coach Jason trained and the techniques that he
                      used made a difference in my sprinting immediately.`,
    },
  ];
  return (
    <>
      <div className="relative pt-16 pb-28">
        <div className="w-full max-w-md mx-auto px-5">
          <div className="mb-20 text-center">
            <h4 className="text-black text-center font-roboto font-black text-4xl sm:text-5xl uppercase mb-2">
              THE TRUST.
            </h4>
            <p className="text-gray-800 font-roboto font-medium text-base uppercase">
              WHAT ATHLETES ARE SAYING
            </p>
          </div>

          <div className="testimonial_slider">
            <Swiper
              className="!pb-10"
              spaceBetween={28}
              modules={[Pagination, Autoplay, EffectFade]}
              effect="fade"
              fadeEffect={{ crossFade: true }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                renderBullet: function (index, className) {
                  return `<span class="${className} custom-bullet"></span>`;
                },
              }}
              onSwiper={(swiper) => console.log(swiper)}
            >
              {testimonials.map((item, index) => (
                <SwiperSlide key={index}>
                  <div>
                    <div className="w-full max-w-52 mx-auto flex flex-col justify-center items-center gap-2 mb-10">
                      <div className="size-[66px]">
                        <img
                          src={item.image}
                          alt={item.name}
                          className="w-full h-full rounded-full object-cover"
                        />
                      </div>
                      <div className="font-roboto text-gray-600 font-medium text-sm text-center">
                        <p>
                          {item.name.split(" ")[0]} <br />
                          {item.name.split(" ")[1]}
                        </p>
                      </div>
                    </div>

                    <div className="text-gray-700 font-roboto font-normal text-lg text-center">
                      <p>{item.text}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
};
const TheLast = () => {
  const socialLinks = [
    { id: 1, icon: instagram, alt: "instagram", path: "/" },
    { id: 2, icon: facebook, alt: "facebook", path: "/" },
  ];

  return (
    <>
      <div className="bg-black p-5 pb-10">
        <div className="w-full max-w-lg mx-auto text-center">
          <h5 className="text-white font-roboto font-black text-2xl sm:text-3xl uppercase mb-3">
            SPEED CHANGES EVERYTHING.
          </h5>

          <p className="text-white font-roboto font-medium text-lg">
            Not everyone is willing to earn it.{" "}
          </p>

          <p className="text-white font-roboto font-normal text-sm mt-8">
            Limited enrollment. <br />
            Select athletes accepted.
          </p>

          <div className="w-full max-w-24 mx-auto mt-10">
            <img src={logoCircle} alt="logo" className="w-full h-full" />
          </div>

          <ul className="flex justify-center gap-3 mt-10">
            {socialLinks.map(({ id, icon, alt, path }) => (
              <li key={id}>
                <Link
                  to={path}
                  className="size-6 block hover:opacity-80 transition"
                >
                  <img src={icon} alt={alt} className="w-full h-full" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
